import { effect } from '../../reactivity/effects.js';

/**
 *
 *
 */
export function attach(node, get_fn) {
	effect(() => {
		const fn = get_fn();

		/*                                               */
		/*                                           */
		return fn && fn(node);
	});
}
